import { render, staticRenderFns } from "./64.vue?vue&type=template&id=4a68a350&scoped=true&"
var script = {}
import style0 from "./64.vue?vue&type=style&index=0&id=4a68a350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a68a350",
  null
  
)

export default component.exports